import { ParagraphText, HeadingText, Icon } from '@leagueplatform/genesis-core';
import { Box, Flex, SecondaryButton } from '@leagueplatform/genesis-commons';
import React from 'react';
import { useIntl } from '@leagueplatform/locales';
import { DEPENDENT_RELATIONSHIP_MAP } from '@leagueplatform/web-common';
import { Dependent as _Dependent } from '@leagueplatform/wallet-api';

interface DependentProps {
  dependent: _Dependent;
  viewDependentCard: (dependent: _Dependent) => void;
}

export const Dependent = ({ viewDependentCard, dependent }: DependentProps) => {
  // eslint-disable-next-line @typescript-eslint/naming-convention -- FIXME: automatically added for existing issue
  const { email, first_name, last_name, relationship_type } = dependent;
  const { formatMessage, $tmap } = useIntl();

  const relationshipTypeMessageMap = $tmap<
    keyof typeof DEPENDENT_RELATIONSHIP_MAP
  >({
    spouse: 'SPOUSE',
    common_law: 'COMMON_LAW',
    child: 'CHILD',
    parent: 'PARENT',
    grandparent: 'GRANDPARENT',
    grandchild: 'GRANDCHILD',
    uncle_aunt: 'UNCLE_AUNT',
    nephew_niece: 'NEPHEW_NIECE',
    sibling: 'SIBLING',
    other: 'OTHER',
    domestic_partnership: 'DOMESTIC_PARTNERSHIP',
    ineligible_child: 'INELIGIBLE_CHILD',
  });

  const relationshipTypeMessage =
    DEPENDENT_RELATIONSHIP_MAP[relationship_type] &&
    relationshipTypeMessageMap(relationship_type);

  return (
    <Box
      as="li"
      borderColor="onSurface.border.default"
      borderWidth="thin"
      borderStyle="solid"
      borderRadius="small"
      display="inline-block"
      width={1}
    >
      <Flex
        flexDirection="column"
        justifyContent="space-between"
        padding="one"
        minHeight="100%"
      >
        <Box>
          <HeadingText
            size="lg"
            level="3"
            css={{ marginBottom: '$half' }}
            className="dependent-name"
          >
            {first_name} {last_name}
          </HeadingText>
          {email && (
            <ParagraphText
              css={{ marginTop: '$none' }}
              className="dependent-email"
              data-testid="dependent-email"
            >
              {email}
            </ParagraphText>
          )}
          {relationshipTypeMessage && (
            <ParagraphText
              css={{ marginTop: '$none' }}
              className="dependent-relationship"
            >
              {relationshipTypeMessage}
            </ParagraphText>
          )}
        </Box>
        <SecondaryButton
          aria-label={formatMessage(
            { id: 'VIEW_CARD_FOR_DEPENDENT' },
            { dependentName: `${first_name} ${last_name}` },
          )}
          onClick={() => viewDependentCard(dependent)}
          paddingX="one"
          paddingY="one"
          textAlign="center"
          width={1}
          marginTop="one"
        >
          {formatMessage({ id: 'VIEW_CARD' })}
          <Box as="span" marginInlineStart="half">
            <Icon icon="interfaceChevronRight" />
          </Box>
        </SecondaryButton>
      </Flex>
    </Box>
  );
};
